import React, { createContext, useContext, useState } from 'react';

const LanguageContext = createContext(null);

const defaultLanguage = 'en-US';

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState(() => {
    const storedState = localStorage.getItem('language');
    return storedState ? JSON.parse(storedState) : defaultLanguage;
  });

  const onSetLanguage = (newLanguage) => {
    setLanguage(newLanguage);
    localStorage.setItem('language', JSON.stringify(newLanguage));
  };

  return (
    <LanguageContext.Provider value={{ language, onSetLanguage }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
};
